import { render, staticRenderFns } from "./lote_fecha_ven.vue?vue&type=template&id=63f6717c&"
import script from "./lote_fecha_ven.vue?vue&type=script&lang=js&"
export * from "./lote_fecha_ven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports